import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=094b7350&"
import script from "./Resumen.vue?vue&type=script&lang=js&"
export * from "./Resumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('094b7350', component.options)
    } else {
      api.reload('094b7350', component.options)
    }
    module.hot.accept("./Resumen.vue?vue&type=template&id=094b7350&", function () {
      api.rerender('094b7350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/DetailsResidencial/Resumen.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/DetailsResidencial/Resumen.vue
// module id = YgCR
// module chunks = 0